<div class="form">
  @if (showErrorSummary()) {
    <htx-error-summary-field
      [form]="formGroup()"
      [title]="errorSummaryTitle()"
      [controlNames]="controlNames()"
      [fieldLabels]="fieldLabels()"
      [errorTypeLabels]="errorTypeLabels()"
    ></htx-error-summary-field>
  }

  <form [formGroup]="formGroup()" class="form-container">
    <div class="form-fields">
      <ng-content></ng-content>
    </div>
  </form>
</div>
